import { PageConfig } from "../../config/page.config";
import { FormConstants } from "../constants/form.constants";
import { IAppFormLink } from "./app-form-link"

const formLinks = {
  build(): IAppFormLink[] {
    return [
      {
        formId: 'A',
        formName: 'FormA',
        formType: PageConfig.paths.usan.forms.singleEntityDrugSalt,
        formText: 'Form A - ' + FormConstants.FORM_A_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.singleEntityDrugSalt],
          extras: undefined
        }
      },
      {
        formId: 'B',
        formName: 'FormB',
        formType: PageConfig.paths.usan.forms.singleEntity,
        formText: 'Form B - ' + FormConstants.FORM_B_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.singleEntity],
          extras: undefined
        }
      },
      {
        formId: 'C',
        formName: 'FormC',
        formType: PageConfig.paths.usan.forms.modifiedSalt,
        formText: 'Form C - ' + FormConstants.FORM_C_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.modifiedSalt],
          extras: undefined
        }
      },
      {
        formId: 'D',
        formName: 'FormD',
        formType: PageConfig.paths.usan.forms.revisionToAdoptedUsan,
        formText: 'Form D - ' + FormConstants.FORM_D_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.revisionToAdoptedUsan],
          extras: undefined
        }
      },
      {
        formId: 'E',
        formName: 'FormE',
        formType: PageConfig.paths.usan.forms.contactLensMaterial,
        formText: 'Form E - ' + FormConstants.FORM_E_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.contactLensMaterial],
          extras: undefined
        }
      },
      {
        formId: 'F',
        formName: 'FormF',
        formType: PageConfig.paths.usan.forms.biologics,
        formText: 'Form F - ' + FormConstants.FORM_F_NAME,
        formIcon: 'add',
        formRoute: {
          commands: [PageConfig.paths.usan.root, PageConfig.paths.usan.forms.base, PageConfig.paths.usan.forms.biologics],
          extras: undefined
        }
      }
    ];
  }
}

export default formLinks;
